import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserJigsawPuzzleGame from '../../games/JigsawPuzzleGame/Main';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(JigsawPuzzleGame)'
interface JigsawPuzzleGameProps extends RouteComponentProps<{}> {
    onComplete?: () => void;
}

interface JigsawPuzzleGameState {
}

class JigsawPuzzleGame extends React.Component<JigsawPuzzleGameProps, JigsawPuzzleGameState> {
    constructor(props: JigsawPuzzleGameProps) {
        super(props);
        bindAllOfThis(this, JigsawPuzzleGame.prototype);

        // You are allowed to set defaults here, based on your state object above
        this.state = {
        };
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserJigsawPuzzleGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default JigsawPuzzleGame;



// WEBPACK FOOTER //
// ./src/pages/game/JigsawPuzzleGame.tsx